// extracted by mini-css-extract-plugin
module.exports = {"logo":"HeaderLogo_logo__hsBFZ","logoLink":"HeaderLogo_logoLink__ic0MJ","customDate":"HeaderLogo_customDate___NhNl"};